export enum ThemeModeEnum {
    LIGHT,
    DARK,
}
